module.exports = __webpack_public_path__ + "img/saucisse.e22f32d8.png";